import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { toStateClass } from "../../utils/toStateClass.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
const Label = memo(({
  className,
  isDisabled,
  isActive,
  isFocused,
  isHover,
  children,
  size,
  weight
}) => {
  const componentClassName = `${useClassNamePrefix()}label`;
  const classList = classNames(
    componentClassName,
    toStateClass("active", !isDisabled && isActive),
    toStateClass("focused", !isDisabled && isFocused),
    toStateClass("disabled", isDisabled),
    toStateClass("hover", !isDisabled && isHover),
    toEnumViewClass(size),
    toEnumViewClass(weight),
    className
  );
  return /* @__PURE__ */ jsx("span", { className: classList, children });
});
Label.displayName = "Label";
export {
  Label
};
//# sourceMappingURL=Label.js.map
